import React, { useState } from 'react';

export default function Modify() {
  const [empId, setEmpId] = useState('');
  const [newSalary, setNewSalary] = useState('');
  const [newNetPay, setNewNetPay] = useState('');

  async function handleModifyClick () {
    if (!empId || !newSalary || !newNetPay) {
      alert("Please fill in all fields before modifying.");
      return;
    }

    if (isNaN(empId) || isNaN(newSalary) || isNaN(newNetPay)) {
      alert("Employee ID, New Salary, and New Net Pay must be numerical values.");
      return;
    }

    else{




        // alert(`Employee ID: ${empId}\nNew Salary: ${newSalary}\nNew Net Pay: ${newNetPay}`);

        
      const res = await fetch("https://payrole.onrender.com/modify", {
        method: 'POST',
        body: JSON.stringify({empId,newSalary,newNetPay}),
        headers: { 'Content-Type': 'application/json' }
      });

      const likedpostcreatedtime = await res.json();
      alert(likedpostcreatedtime)

    }

  };

  const containerStyle = {
    width: '300px',
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    boxShadow: '0px 0px 5px 2px #888',
    margin: '0 auto',
    textAlign: 'center',
    backgroundColor: '#fff',
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    marginBottom: '10px',
  };

  const buttonStyle = {
    width: '100%',
    padding: '10px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  };

  const buttonHoverStyle = {
    backgroundColor: '#0056b3',
  };

  return (
    <div style={containerStyle}>
      <input
        type="text"
        placeholder="Employee ID"
        value={empId}
        onChange={(e) => setEmpId(e.target.value)}
        style={inputStyle}
      />
      <br />
      <input
        type="text"
        placeholder="New Salary"
        value={newSalary}
        onChange={(e) => setNewSalary(e.target.value)}
        style={inputStyle}
      />
      <br />
      <input
        type="text"
        placeholder="New Net Pay"
        value={newNetPay}
        onChange={(e) => setNewNetPay(e.target.value)}
        style={inputStyle}
      />
      <br />
      <button
        onClick={handleModifyClick}
        style={buttonStyle}
        onMouseOver={(e) => e.target.style.backgroundColor = buttonHoverStyle.backgroundColor}
        onMouseOut={(e) => e.target.style.backgroundColor = buttonStyle.backgroundColor}
      >
        Modify
      </button>
    </div>
  );
}